import React from 'react';
import BasicInfoStep from '../../../../Forms/Steps/BasicInfoStep';
import { basicInfoFields } from '../Helpers/CopyAndFunctions';


const BasicInfoFields = () => {
  
  return (
    <BasicInfoStep fields={basicInfoFields} />
  );
};

export default BasicInfoFields;
